module.exports = __webpack_public_path__ + "img/rosepetal-dep-juveycamps.0399fb8e.jpg";